module.exports = __webpack_public_path__ + "static/media/rich-Image.abe4f527.jpeg";